/** The site's mark. LLM Opex is a gauge: an arc, a needle and a base line,
 *  drawn inline so the needle takes the text colour and follows the theme. */
import { BASE } from '../api'

export function Mark({ className = 'mark', size }: { className?: string; size?: number }) {
  const style = size ? { width: size, height: size } : undefined
  return (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true" style={style}>
      <path d="M11 38 A21 21 0 1 1 53 38" fill="none" stroke="#9333ea" strokeWidth="7" strokeLinecap="round" />
      <path d="M32 38 L46 22" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
      <circle cx="32" cy="38" r="5" fill="currentColor" />
      <rect x="20" y="48" width="24" height="5" rx="2.5" fill="#9333ea" />
    </svg>
  )
}

/** The browser-tab and home-screen icons: the page's head names the plain files, the gauge's are set here. */
export function useFavicons() {
  const suffix = '-opex'
  for (const [sel, file] of [
    ['link[rel="icon"][sizes="48x48"]', `favicon${suffix}.png`],
    ['link[rel="icon"][sizes="32x32"]', `favicon${suffix}-32.png`],
    ['link[rel="apple-touch-icon"]', `apple-touch-icon${suffix}.png`],
  ] as const) {
    const link = document.querySelector<HTMLLinkElement>(sel)
    if (link && !link.href.endsWith(`/${file}`)) link.href = `${BASE}${file}`
  }
}
